import React, {useEffect, useState} from 'react'

import cx from 'classnames'
import PropTypes from 'prop-types'

const FADE_OUT_TIME = 300

const AnimationFadeOut = ({
  start = false,
  extraClassNames = '',
  children,
  time = FADE_OUT_TIME,
  callback = () => {}
}) => {
  const [show, setShow] = useState(true)

  const classNames = cx('mt-AnimationFadeOut', extraClassNames, {
    'mt-AnimationFadeOut-enter': start
  })

  useEffect(
    () => {
      if (start)
        setTimeout(() => {
          setShow(false)
          callback()
        }, time)
    },
    [start, time] // eslint-disable-line react-hooks/exhaustive-deps
  )

  return show ? <div className={classNames}>{children}</div> : <> </>
}

AnimationFadeOut.displayName = 'AnimationFadeOut'

AnimationFadeOut.propTypes = {
  start: PropTypes.bool,
  extraClassNames: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  children: PropTypes.node.isRequired,
  time: PropTypes.number,
  callback: PropTypes.func
}

export default AnimationFadeOut
